import React, {Component} from 'react';
import VideoContainer from "../../utils/VideoContainer";
import Timeformat from "../../utils/Timeformat";
import PropTypes from "prop-types";

class VideoMedium extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

    }

    getItems() {

        if (this.props.videoList.length > 0) {
            return this.props.videoList.map(
                (item) => this.renderItem(item)
            );
        }

        return this.translate('noViewFound');

    }

    renderItem(item) {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const classes = ['archivContainer', 'col-md-4'].join(' ').trim();
        const published = (item.videoPublished) ? Timeformat.fromUnix(item.videoPublished).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

        return (
            <div key={'video-' + item.videoId} className={classes}>
                <div className="archivBox" style={{backgroundColor: '#EAEDEF'}}>
                    <div className="clearfix">
                        <div className="archivBlock fll">
                            <VideoContainer videoId={item.videoId}
                                            videoDisabled={(item.videoDisabled === 'true')}
                                            videoSource={this.props.source}
                                            useBootstrap={false}
                                            onClick={this.props.onClick}
                            />
                        </div>

                        <div className="archivBlock paddingBox5 flr">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left">{this.translate('name')}</td>
                                        <td className="text-left">{item.videoTitle}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">{this.translate('length')}</td>
                                        <td className="text-left">{item.videoLength}</td>
                                    </tr>
                                    {/*<tr>
                                        <td className="text-left">{this.translate('views')}</td>
                                        <td className="text-left">{item.videoViews}</td>
                                    </tr>*/}
                                    <tr>
                                        <td className="text-left">{this.translate('published')}</td>
                                        <td className="text-left">{published}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="archivBlock">
                        {(item.videoDescription) ? item.videoDescription : this.translate('noDescriptionMsg')}
                    </div>
                </div>
            </div>
        );

    }

    render() {

        let items = this.getItems();

        return items;

    }

}

export default VideoMedium;
